<template>
  <div>
    <pre-game-modal v-if="isPreGameModalOpen" @close:modal="handleClosePreGameModal"></pre-game-modal>

    <base-modal v-else modal-content-class="rest confirm_purch">
      <div class="content">
        <h1>{{ $_getTranslations.home_modals_confirm_purchase_successfull_purchase }}</h1>

        <p class="mt-40">{{ $_getTranslations.home_modals_confirm_purchase_well_done }}</p>

        <p class="games-to-price">
          <span>{{ getBundleData.numberOfGames }}</span>
          {{ $_getTranslations.home_modals_confirm_purchase_successfull_games_were_unlocked }}
        </p>

        <p>{{ $_getTranslations.home_modals_confirm_purchase_successfull_do_you_want_to_start_new_game }}</p>

        <base-button @button:click="handleNewGame">
          {{ $_getTranslations.home_modals_confirm_purchase_successfull_new_game }}
        </base-button>
      </div>
    </base-modal>
  </div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'
import BaseModal from '../../../common/modal/BaseModal'
import BaseButton from '../../../common/button/BaseButton'
import NewGameModal from '../pregame/NewGameModal'
import PreGameModal from '../pregame/PreGameModal'
import translationMixin from '../../../../common/mixins/translation'
import modals from '../../../../common/modals'

export default {
  name: 'confirmPurchaseSuccessful',
  components: {
    BaseModal,
    BaseButton,
    NewGameModal,
    PreGameModal
  },
  mixins: [translationMixin],
  data () {
    return {
      isPreGameModalOpen: false
    }
  },
  methods: {
    ...mapMutations('common', [
      'storeModalForStore'
    ]),
    handleNewGame () {
      modals.hideCommonModal({
        immediate: true,
        afterHideCallback: () => {
          this.isPreGameModalOpen = true
        }
      })
    },
    handleClosePreGameModal () {
      this.storeModalForStore(null)
    }
  },
  computed: {
    ...mapGetters('profile', [
      'getBundleData'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home/modals/store/ConfirmPurchaseSuccessful.vue